export default __webpack_public_path__ + "edf215c65f806a55f891c0ba2856cd23.svg";